import { render, staticRenderFns } from "./CommonIframe.vue?vue&type=template&id=1c691427&"
import script from "./CommonIframe.vue?vue&type=script&lang=js&"
export * from "./CommonIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports